import React, { useContext, useEffect, useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../datepicker.css";
import { BsCalendar } from "react-icons/bs";
import tr from "date-fns/locale/tr";
import enUS from "date-fns/locale/en-US"; // İngilizce dil paketi eklendi
import { RoomContext } from "../context/RoomContext";

// İki dili de sisteme kaydediyoruz
registerLocale("tr", tr);
registerLocale("en", enUS);

const CheckIn = () => {
  const { checkInDate, setCheckInDate } = useContext(RoomContext);
  const [lang, setLang] = useState("tr"); // Varsayılan dil Türkçe

  useEffect(() => {
    // Sayfa yüklendiğinde çerezlerden (cookie) seçili dili kontrol et
    const isEnglish = document.cookie.includes("googtrans=/tr/en");
    if (isEnglish) {
      setLang("en");
    } else {
      setLang("tr");
    }
  }, []);

  return (
    <div className="relative flex items-center justify-end h-full">
      <div className="absolute z-10 pr-8">
        <BsCalendar className="text-accent text-base" />
      </div>

      <DatePicker
        className="w-full h-full"
        selected={checkInDate}
        onChange={(date) => setCheckInDate(date)}
        // Dil İngilizce ise placeholder değişsin
        placeholderText={lang === "en" ? "Check-in Date" : "Giriş Tarihi"}
        locale={lang} // Dinamik dil değeri (tr veya en)
        minDate={new Date()}
        calendarClassName="notranslate"
      />
    </div>
  );
};

export default CheckIn;